export default (props, traits) => {
  return {
    root: {
      textAlign: 'center'
    },

    copy: {
      marginBottom: traits.rhythm(1)
    }
  }
}
